import { useMutation } from '@tanstack/react-query';
import { gerarRelatorioCsvApi } from '../api/GerarRelatorioCSVApi';
import type { GerarRelatorioCSVResponse, GerarRelatorioPayload } from '../types';

export function useGerarRelatorioCSV() {
  return useMutation<GerarRelatorioCSVResponse, Error, GerarRelatorioPayload>({
    mutationFn: gerarRelatorioCsvApi,
  });
}
